<template>
  <a-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :footer="null"
    @cancel="handleCancel"
  >
    <a-spin :spinning="loading">
      <a-table
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        @change="handleTableChange"
        size="small"
        rowKey="id"
      >
        <span slot="goodsName" slot-scope="text, record">
          {{ text || '-' }}
          <div style="font-size: 12px; color: #999;">SKU: {{ record.skuName || '-' }}</div>
        </span>
        <span slot="returnReason" slot-scope="text">
          <a-tag v-if="text === 1" color="red">质量问题</a-tag>
          <a-tag v-else-if="text === 2" color="orange">错发漏发</a-tag>
          <a-tag v-else-if="text === 3" color="blue">滞销退货</a-tag>
          <a-tag v-else color="default">其他</a-tag>
        </span>
        <span slot="createTime" slot-scope="text">
          {{ parseTime(text) }}
        </span>
      </a-table>
    </a-spin>
  </a-modal>
</template>

<script>
import { getReturnRecordList } from '@/api/retail/inventory'
import moment from 'moment'

export default {
  name: 'ReturnRecordModal',
  data() {
    return {
      visible: false,
      loading: false,
      title: '采购退货记录',
      list: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条`
      },
      columns: [
        {
          title: '商品名称',
          dataIndex: 'goodsName',
          key: 'goodsName',
          width: 200,
          scopedSlots: { customRender: 'goodsName' }
        },
        {
          title: '退货数量',
          dataIndex: 'returnStock',
          key: 'returnStock',
          width: 100,
          align: 'center'
        },
        {
          title: '退货原因',
          dataIndex: 'returnReason',
          key: 'returnReason',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'returnReason' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          key: 'remark',
          width: 200,
          ellipsis: true
        },
        {
          title: '操作人',
          dataIndex: 'creatorName',
          key: 'creatorName',
          width: 100,
          align: 'center'
        },
        {
          title: '退货时间',
          dataIndex: 'createTime',
          key: 'createTime',
          width: 180,
          align: 'center',
          scopedSlots: { customRender: 'createTime' }
        }
      ]
    }
  },
  methods: {
    moment,
    parseTime(time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    handleShow() {
      this.visible = true
      this.getList()
    },
    getList() {
      this.loading = true
      getReturnRecordList({
        current: this.pagination.current,
        size: this.pagination.pageSize
      }).then(response => {
        if (response.data && response.data.records) {
          this.list = response.data.records
          this.pagination.total = response.data.total || 0
        } else {
          this.list = []
          this.pagination.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleTableChange(pagination) {
      this.pagination = pagination
      this.getList()
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
